import { apiClient } from './api';
import { Pest, Disease } from '../types';

export const PestDiseaseService = {
  // Pests
  async getPests(params?: { search?: string; category?: string; limit?: number; offset?: number }) {
    return apiClient.get<{ success: boolean; data: Pest[] }>('/pests-diseases/pests', {
      params,
    });
  },

  async getPest(idOrSlug: string) {
    return apiClient.get<{ success: boolean; data: Pest }>(`/pests-diseases/pests/${idOrSlug}`);
  },

  // Diseases
  async getDiseases(params?: {
    search?: string;
    category?: string;
    limit?: number;
    offset?: number;
  }) {
    return apiClient.get<{ success: boolean; data: Disease[] }>('/pests-diseases/diseases', {
      params,
    });
  },

  async getDisease(idOrSlug: string) {
    return apiClient.get<{ success: boolean; data: Disease }>(
      `/pests-diseases/diseases/${idOrSlug}`,
    );
  },

  // Species relations
  async getSpeciesPests(speciesId: string) {
    return apiClient.get<{ success: boolean; data: any }>(
      `/pests-diseases/species/${speciesId}/pests`,
    );
  },

  async getSpeciesDiseases(speciesId: string) {
    return apiClient.get<{ success: boolean; data: any }>(
      `/pests-diseases/species/${speciesId}/diseases`,
    );
  },

  // Reverse lookups: which species are affected
  async getPestSpecies(pestId: string) {
    return apiClient.get<{ success: boolean; data: any[] }>(`/pests-diseases/pests/${pestId}/species`);
  },

  async getDiseaseSpecies(diseaseId: string) {
    return apiClient.get<{ success: boolean; data: any[] }>(`/pests-diseases/diseases/${diseaseId}/species`);
  },

  // Create custom entries
  async createPest(data: {
    name_ui: string;
    category?: string;
    identification?: any;
    control?: any;
    default_severity?: number;
  }) {
    return apiClient.post<{ success: boolean; data: Pest }>('/pests-diseases/pests', data);
  },

  async createDisease(data: {
    name_ui: string;
    category?: string;
    identification?: any;
    control?: any;
    default_severity?: number;
  }) {
    return apiClient.post<{ success: boolean; data: Disease }>('/pests-diseases/diseases', data);
  },
};
